export default function removeWhitespaces(input: string | undefined): string {
  return !!input ? input.replace(/\s/g, "") : "";
}
